
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.775 48.812a1 1 0 001.534 1.282L33.608 23.36l.007-.009L46.756 7.913a1 1 0 00-.126-1.42l-.687-.566-.679-.576a1 1 0 00-1.42.127l-12.87 15.665-.007.009-22.192 27.66zM11.168 51.275a1 1 0 001.36 1.466L39 29.157l.008-.008 14.983-13.658a1 1 0 00.06-1.419l-1.213-1.306a1 1 0 00-1.419-.048L36.668 26.625l-.009.009-25.491 24.641z"}})])
          )
        }
      }
    